import { Injectable } from '@angular/core';
import { timer } from 'rxjs';
import { finalize, take } from 'rxjs/operators';

import { LocalStorageKeys } from 'src/app/configs/local-storage-keys-config';
import { AppIntroService } from 'src/app/layout/components/app-intro/app-intro.service';
import { Assets } from 'src/assets/assets';
import { AppDirection } from './../types/app-direction.type';
import { AppThemeMode } from './../types/app-theme-mode.type';
import { AppDomService } from './dom.service';

@Injectable({
  providedIn: 'root',
})
export class AppStyleService {
  //#region properties
  source = timer(1000, 1000); //timer
  themeMode: AppThemeMode = 'light';
  appDirection: AppDirection = 'rtl';

  //#region app style
  styleId: string = 'app-style';
  appStyleUrl: string = Assets.appStyleUrl;
  appStyleRtlUrl: string = Assets.appStyleRtlUrl;
  currentStyle: HTMLElement;
  currentStylePath: string;
  //#endregion

  //#endregion

  constructor(private appIntroService: AppIntroService) {}

  //#region Theme Mode

  initThemeMode(): AppThemeMode {
    this.themeMode = this.getThemeModeFromLocalStorage();

    if (!this.themeMode) {
      this.themeMode = 'light';
      this.setThemeModeInLocalStorage(this.themeMode);
    }

    document.documentElement.className =
      this.themeMode == 'dark' ? 'dark tw-dark' : 'light tw-light';
    document.documentElement.setAttribute(
      'data-theme',
      this.themeMode == 'dark' ? 'dracula' : ''
    );

    return this.themeMode;
  }

  getThemeModeFromLocalStorage(): AppThemeMode {
    return localStorage.getItem(LocalStorageKeys.themeMode) as AppThemeMode;
  }

  setThemeModeInLocalStorage(mode: AppThemeMode) {
    document.documentElement.className =
      mode == 'dark' ? 'dark tw-dark' : 'light tw-light';
    document.documentElement.setAttribute(
      'data-theme',
      mode == 'dark' ? 'dracula' : ''
    );

    localStorage.setItem(LocalStorageKeys.themeMode, mode);
  }

  //#endregion

  //#region app Style

  setAppStyle() {
    this.appDirection = this.getAppDirection();
    this.currentStyle = this.getCurrentStyleById(this.styleId);
    this.currentStylePath = this.getStylePath(this.currentStyle);

    if (this.appDirection === 'rtl') {
      if (this.currentStylePath === this.appStyleRtlUrl) return;

      //create Style
      let link = this.createStyleElement(this.styleId, this.appStyleRtlUrl);
      //add style to html
      this.addStyleToHTML(this.currentStyle, link);
    } else if (this.appDirection === 'ltr') {
      if (this.currentStylePath === this.appStyleUrl) return;

      //create Style
      let link = this.createStyleElement(this.styleId, this.appStyleUrl);
      //add style to html
      this.addStyleToHTML(this.currentStyle, link);
    }
  }

  getAppDirection(): AppDirection {
    return localStorage.getItem(LocalStorageKeys.dir) as AppDirection;
  }

  getCurrentStyleById(id: string): HTMLElement {
    return document.getElementById(id);
  }

  getStylePath(elementStyle: HTMLElement): string {
    return elementStyle.getAttribute('href');
  }

  createStyleElement(styleId, stylePath): any {
    let link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = stylePath;
    link.id = styleId;

    return link;
  }

  addStyleToHTML(oldStyle, newStyle) {
    //add new style
    let timeOut = setTimeout(() => {
      if (oldStyle) {
        oldStyle.after(newStyle);
        oldStyle.remove();

        clearTimeout(timeOut);
      }
    }, 200);

    //hide loading
    this.hideLoadingByTimer();
  }

  hideLoadingByTimer() {
    AppDomService.hideAppScroll();
    this.appIntroService.setVisible(true);

    this.source
      .pipe(
        take(5),
        finalize(() => {
          // this.appIntroService.setVisible(false);
        })
      )
      .subscribe();
  }

  //#endregion
}
